import ScalarSidebarIndent_default from "./ScalarSidebarIndent.vue.js";
import { useBindCx } from "@scalar/use-hooks/useBindCx";
import { createElementBlock, createVNode, defineComponent, guardReactiveProps, normalizeProps, openBlock, unref } from "vue";
var ScalarSidebarSpacer_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarSidebarSpacer",
	props: { indent: { default: 0 } },
	setup(__props) {
		const { cx } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", normalizeProps(guardReactiveProps(unref(cx)("flex shrink-0 px-2 h-1"))), [createVNode(ScalarSidebarIndent_default, { indent: __props.indent }, null, 8, ["indent"])], 16);
		};
	}
});
//#endregion
export { ScalarSidebarSpacer_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarSidebarSpacer.vue_vue_type_script_setup_true_lang.js.map